module.exports = __webpack_public_path__ + "static/media/stop-6.4261d09f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-6.svg
// module id = 1351
// module chunks = 0